import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ClientStatus } from '@fitness-force/enum';
import { AgePipe } from '@fitness-force/shared-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'age-cell',
  templateUrl: './age-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AgePipe, AsyncPipe],
})
export class AgeCellComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  constructor() {}

  ngOnInit(): void {}

  isMebersStatus(data: any) {
    var clientStatus =
      ClientStatus[data.client_status as keyof typeof ClientStatus];
    if (clientStatus == ClientStatus.Client) return true;
    else return true;
  }
}
